<template>
  <div class="tab">
    <main class="page_container">
      <TableLogs :data="data" :loading="loading" :link-keys="linkKeys" :keys="keys" @fetch="onFetchData" />
    </main>
  </div>
</template>
<script>
import TableLogs from "@/core/components/TableLogs/index";
import { ApiService } from "@/api";
import logsMixin from "@/core/components/TableLogs/logsMixin";

export default {
  name: "CameraLogs",
  components: {
    TableLogs,
  },
  mixins: [logsMixin],
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      keys: [
        "id_account_master",
        "id_server",
        "shared_address",
        "id_recipient",
        "access_archive",
        "ip",
        "is_access_share",
        "management_company_str",
        "need_sound",
        "short_name",
        "status",
        "adress",
        "address",
        "archive_depth",
        "switch",
        "description",
        "fias_guid",
        "id_model",
        "id_operator",
        "id_sidetask_setting",
        "id_transcoding_server",
        "is_push_camera",
        "mute_sound",
        "public_access",
        "timezone"
      ],
      linkKeys: {
        id_account_master: `${process.env.BASE_URL}#/client/edit/`,
        id_server: `${process.env.BASE_URL}#/media_server/edit/`,
        id_recipient: `${process.env.BASE_URL}#/client/edit/`,
      },
    };
  },
  methods: {
    fetchLogs(params) {
      return ApiService.logs.getCameraLogs(this.id, params);
    },
  },
};
</script>
